/**
 * How To Use Carousel — oddit-section-how-to-use
 * Horizontal scrolling carousel with snap, arrow navigation, and dot indicators.
 */
(function () {
  'use strict';

  function initHowToUse(sectionEl) {
    var section = sectionEl || document.querySelector('.oddit-section-how-to-use');
    if (!section) return;

    var track = section.querySelector('.oddit-section-how-to-use__carousel-track');
    if (!track) return;

    var prevBtn = section.querySelector('.oddit-section-how-to-use__carousel-arrow--prev');
    var nextBtn = section.querySelector('.oddit-section-how-to-use__carousel-arrow--next');
    var indicatorContainer = section.querySelector('.oddit-section-how-to-use__carousel-indicators');
    var cards = Array.from(track.querySelectorAll('.oddit-section-how-to-use__card'));

    if (!cards.length) return;

    var hasCarousel = prevBtn && nextBtn && indicatorContainer;

    /* ---- Helpers ---- */

    function getVisibleCount() {
      var trackWidth = track.clientWidth;
      var cardWidth = cards[0].offsetWidth;
      var gap = parseInt(getComputedStyle(track).gap, 10) || 0;
      return Math.max(1, Math.floor((trackWidth + gap) / (cardWidth + gap)));
    }

    function getTotalPages() {
      return Math.max(1, cards.length - getVisibleCount() + 1);
    }

    function getCurrentPage() {
      var cardWidth = cards[0].offsetWidth;
      var gap = parseInt(getComputedStyle(track).gap, 10) || 0;
      var scrollLeft = track.scrollLeft;
      return Math.round(scrollLeft / (cardWidth + gap));
    }

    /* ---- Dot Indicators ---- */

    function buildDots() {
      if (!indicatorContainer) return;
      indicatorContainer.innerHTML = '';
      var totalPages = getTotalPages();
      for (var i = 0; i < totalPages; i++) {
        var dot = document.createElement('button');
        dot.className = 'oddit-section-how-to-use__carousel-dot';
        dot.setAttribute('aria-label', 'Go to card ' + (i + 1));
        dot.setAttribute('type', 'button');
        if (i === 0) dot.classList.add('oddit-section-how-to-use__carousel-dot--active');
        dot.addEventListener('click', (function (index) {
          return function () {
            scrollToPage(index);
          };
        })(i));
        indicatorContainer.appendChild(dot);
      }
    }

    function updateDots() {
      if (!indicatorContainer) return;
      var page = getCurrentPage();
      var dots = indicatorContainer.querySelectorAll('.oddit-section-how-to-use__carousel-dot');
      dots.forEach(function (dot, i) {
        dot.classList.toggle('oddit-section-how-to-use__carousel-dot--active', i === page);
      });
      updateArrowColors(page);
    }

    function updateArrowColors(page) {
      if (!prevBtn || !nextBtn) return;
      var totalPages = getTotalPages();
      var prevSvgPath = prevBtn.querySelector('path');
      var nextSvgPath = nextBtn.querySelector('path');
      var prevColor = page <= 0 ? '#9E9E9E' : '#000000';
      var nextColor = page >= totalPages - 1 ? '#9E9E9E' : '#000000';
      if (prevSvgPath) {
        prevSvgPath.setAttribute('fill', prevColor);
      }
      if (nextSvgPath) {
        nextSvgPath.setAttribute('fill', nextColor);
      }
    }

    /* ---- Scroll ---- */

    function scrollToPage(page) {
      var cardWidth = cards[0].offsetWidth;
      var gap = parseInt(getComputedStyle(track).gap, 10) || 0;
      var target = page * (cardWidth + gap);
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function onPrevClick() {
      var page = getCurrentPage();
      if (page > 0) scrollToPage(page - 1);
    }

    function onNextClick() {
      var page = getCurrentPage();
      if (page < getTotalPages() - 1) scrollToPage(page + 1);
    }

    /* ---- Scroll listener for dot sync ---- */

    var scrollTimeout;
    function onTrackScroll() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateDots, 80);
    }

    /* ---- Resize ---- */

    var resizeTimeout;
    function onWindowResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        buildDots();
        updateDots();
      }, 150);
    }

    /* ---- Bind ---- */

    if (hasCarousel) {
      prevBtn.addEventListener('click', onPrevClick);
      nextBtn.addEventListener('click', onNextClick);
    }
    track.addEventListener('scroll', onTrackScroll, { passive: true });
    window.addEventListener('resize', onWindowResize);

    /* ---- Init ---- */

    buildDots();
    updateArrowColors(0);

    /* ---- Cleanup (for theme editor) ---- */

    section._howToUseCleanup = function () {
      if (hasCarousel) {
        prevBtn.removeEventListener('click', onPrevClick);
        nextBtn.removeEventListener('click', onNextClick);
      }
      track.removeEventListener('scroll', onTrackScroll);
      window.removeEventListener('resize', onWindowResize);
      clearTimeout(scrollTimeout);
      clearTimeout(resizeTimeout);
    };
  }

  /* ---- Theme Editor Events ---- */

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.oddit-section-how-to-use');
    if (section) initHowToUse(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.oddit-section-how-to-use');
    if (section && typeof section._howToUseCleanup === 'function') {
      section._howToUseCleanup();
    }
  });

  /* ---- Initial page load ---- */

  initHowToUse(null);
})();